import { render, staticRenderFns } from "./bodyBasis.vue?vue&type=template&id=7f1d52fd&scoped=true"
import script from "./bodyBasis.vue?vue&type=script&lang=js"
export * from "./bodyBasis.vue?vue&type=script&lang=js"
import style0 from "./bodyBasis.vue?vue&type=style&index=0&id=7f1d52fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d52fd",
  null
  
)

export default component.exports